/*
Veneer
--species <string::enum> | [<Any Lumber Species>]
--core <string::enum> | ['Particle Board', 'MDF']
--coreThickness <float> | inches
--match <string::enum> | ['Sequence', 'Book', 'Slip']

--grade <boolean::switch> | ['Good 1 Side', 'Good 2 Side']

NOTE: These 2 attributes are are rare, can be considered custom, ignore on reports
--moistureResistant <boolean::checkbox>
--fireRated <boolean::checkbox>

--manufacturers {
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
}
*/
import {
  certification,
  cut,
  length,
  species,
  thickness,
  width
} from '@/modules/standardItems/schemas/baseHeaders'

export default [
  species(),
  cut(),
  thickness(),
  width(),
  length(),
  {
    text: 'Core',
    value: 'core',
    sortable: true,
    sort: 'string'
  },
  {
    text: 'Core Thickness (in)',
    value: 'coreThickness',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    unit: 'inches'
  },
  {
    text: 'Match',
    value: 'match',
    sortable: true,
    sort: 'string'
  },
  {
    text: 'Grade',
    value: 'grade',
    sortable: true,
    sort: 'string'
  },
  {
    text: 'Centered',
    value: 'centered',
    sortable: true,
    sort: 'boolean',
    render: 'boolean',
    align: 'center'
  },
  {
    text: 'Prefinished',
    value: 'prefinished',
    sortable: true,
    sort: 'boolean',
    render: 'boolean',
    align: 'center'
  },
  certification()
]
